
// @ts-check

import DEBUG from './Debugging';
import { getApiUrl } from './urls';

/**
 * @typedef {import('./coreTypes').ResultAtom} ResultAtom
 * @typedef {import('./coreTypes').ResultAtomPartial} ResultAtomPartial
 * @typedef {import('./coreTypes').JSResultAtom} JSResultAtom
 * @typedef {import('./coreTypes').QuerySpec} QuerySpec
 */


/**
 * @param {QuerySpec} querySpec
 * @param {number} offset
 * @param {number} size
 * @param {function(string): void} continuation
 * @return {void}
 */
 function performQuerySpecApiRequest(querySpec, offset, size, continuation)
 {
      const payload = { "query_spec": querySpec, "offset": offset, "size": size };
      
      if (DEBUG) {
          console.log("Query: ", payload);
      }
  
      const req = new XMLHttpRequest();
      req.open("POST", getApiUrl(), true);
      req.setRequestHeader("Content-Type", "application/json");
      
      
      req.addEventListener('load', event => {
          if (DEBUG) {
              console.log("responseText: ", req.responseText);
          }
          
          continuation(req.responseText);
      });
      
      // TODO: handling for resending requests
      // req.addEventListener('onreadystatechange', event => {
          // console.log("got readystate change: " + event.readyState);
          // if (event.readyState === 4) {
              // continuation(event.responseText);
          // }
      // });
      
      if (DEBUG) {
          console.log("Sending performQuerySpec request: " + JSON.stringify(payload));
      }
  
      req.send(JSON.stringify(payload));
 }

 /**
  * @param {QuerySpec} querySpec 
  * @param {number} offset 
  * @param {number} size 
  * @return {Promise<ResultAtomPartial[]>}
  */
 function performQuerySpecApiRequestPromise(querySpec, offset, size) {
    return new Promise((resolve, error) => {
        /** @type {function(string):void} */
        const handler = response => {
            /** @type {ResultAtomPartial[]} */
            let parsedResponse;
            try {
                parsedResponse = JSON.parse(response);
            } catch(e) {
                error(e);
                return;
            }
            resolve(parsedResponse);
        };

        performQuerySpecApiRequest(querySpec, offset, size, handler);
    });
 }

 export { performQuerySpecApiRequest, performQuerySpecApiRequestPromise };